module.exports = __webpack_public_path__ + "img/inge-v6-7.60e97575.png";